<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div
          style="min-height: 80vh"
          v-if="this.isloading"
          class="data__loading"
        >
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <div v-if="!this.isloading">
          <div class="section__top">
            <h2 class="section__title">
              {{ this.student.name }}
            </h2>
            <div class="section__buttons">
              <button
                class="btn add"
                data-bs-toggle="modal"
                data-bs-target="#addStudentModal"
              >
                <i class="fas fa-plus ms-1"></i>
                أضف محتوى للطالب
              </button>

              <!-- Add Modal Start -->
              <div
                class="modal fade"
                id="addStudentModal"
                tabindex="-1"
                aria-labelledby="addStudentModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">أضف محتوى للطالب</h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <form @submit.prevent="addContent($event)">
                        <div class="row">
                          <div class="col-12 col-md-6">
                            <div class="form-group">
                              <label for="numberofviews">مرات المشاهدة</label>
                              <input
                                class="form-control"
                                type="number"
                                placeholder="عدد مرات المشاهدة"
                                v-model="code.number_of_views"
                                id="numberofviews"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-12 col-md-6">
                            <div class="form-group">
                              <label for="numberofviews">تاريخ الانتهاء</label>
                              <input
                                class="form-control"
                                type="datetime-local"
                                placeholder="تاريخ الانتهاء"
                                v-model="code.expired_date"
                                id="numberofviews"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-12">
                            <!-- Content type -->
                            <div class="form-group">
                              <label>نوع المحتوى</label>
                              <select
                                class="form-control form-select"
                                aria-label="Default select"
                                v-model="contentType"
                                required
                              >
                                <option selected disabled :value="0">
                                  اختيار نوع المحتوى
                                </option>
                                <option :value="1">درس</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-12 col-md-6">
                            <div class="form-group">
                              <label>التصنيف</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="mainCategory"
                                required
                                @change="
                                  onSelectMainCategory($event.target.value)
                                "
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.Maincategories"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </div>

                          <!-- Sub Category -->
                          <Transition name="scale" mode="out-in">
                            <div class="col-12 col-md-6">
                              <div
                                class="form-group"
                                v-if="this.subSelect.length > 0"
                              >
                                <label>تصنيف فرعى</label>
                                <select
                                  class="form-select form-control mt-2"
                                  aria-label="Default select "
                                  id="subCategory"
                                  @change="
                                    onSelectSubCategory($event.target.value)
                                  "
                                >
                                  <option selected disabled :value="0">
                                    اختار التصنيف
                                  </option>
                                  <option
                                    v-for="category in this.subSelect"
                                    :key="category.category_id"
                                    :value="category.title"
                                  >
                                    {{ category.title }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </Transition>
                          <!-- Sub Sub Category -->
                          <Transition name="scale" mode="out-in">
                            <div class="col-12 col-md-6">
                              <div
                                class="form-group"
                                v-if="this.subSubSelect.length > 0"
                              >
                                <label>تصنيف فرعى</label>
                                <select
                                  class="form-select form-control mt-2"
                                  aria-label="Default select "
                                  @change="
                                    onSelectSubSubCategory($event.target.value)
                                  "
                                >
                                  <option selected disabled value="">
                                    اختار التصنيف
                                  </option>
                                  <option
                                    v-for="category in this.subSubSelect"
                                    :key="category.category_id"
                                    :value="category.title"
                                  >
                                    {{ category.title }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </Transition>
                          <!-- Sub Sub Sub Category -->
                          <Transition name="scale" mode="out-in">
                            <div class="col-12 col-md-6">
                              <div
                                class="form-group"
                                v-if="this.subSubSubSelect.length > 0"
                              >
                                <label>تصنيف فرعى</label>
                                <select
                                  class="form-select form-control mt-2"
                                  aria-label="Default select "
                                  @change="
                                    onSelectSubSubSubCategory(
                                      $event.target.value
                                    )
                                  "
                                >
                                  <option selected disabled value="">
                                    اختار التصنيف
                                  </option>
                                  <option
                                    v-for="category in this.subSubSubSelect"
                                    :key="category.category_id"
                                    :value="category.title"
                                  >
                                    {{ category.title }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </Transition>

                          <!-- Add Lesson -->
                          <Transition name="scale" mode="out-in">
                            <div class="col-12" v-if="contentType === 1">
                              <div class="form-group">
                                <label>الدروس</label>

                                <select
                                  v-if="lessonsList.length > 0"
                                  class="form-control form-select"
                                  aria-label="Default select"
                                  required
                                  @change="onSelectLesson($event.target.value)"
                                >
                                  <option selected disabled :value="0">
                                    اختيار الدرس
                                  </option>
                                  <option
                                    v-for="(lesson, index) in this.lessonsList"
                                    :key="index"
                                    :value="index"
                                  >
                                    {{ lesson.title }}
                                  </option>
                                </select>
                                <div v-else class="text-center">
                                  <span>لا يوجد دروس حتى الان</span>
                                </div>
                              </div>
                            </div>
                          </Transition>
                          <!-- if Lesson have Videos -->
                          <Transition name="scale" mode="out-in">
                            <div
                              class="col-12"
                              v-if="lessonSelect.contents.length > 0"
                            >
                              <div class="form-group">
                                <label>محتوى الدرس (اختيارى)</label>
                                <select
                                  v-if="this.videosList.length > 0"
                                  class="form-control form-select"
                                  aria-label="Default select"
                                  @change="onSelectContent($event.target.value)"
                                >
                                  <option selected :value="0">
                                    اختيار محتوى معين داخل الدرس
                                  </option>
                                  <option
                                    v-for="(video, index) in this.videosList"
                                    :key="index"
                                    :value="index"
                                  >
                                    {{ video.title }}
                                  </option>
                                </select>
                                <div v-else class="text-center">
                                  <span>لا يوجد محتوى للدروس حتى الان</span>
                                </div>
                              </div>
                            </div>
                          </Transition>

                          <!-- Buttons -->
                          <div class="col-12">
                            <div class="form-group text-start mt-4">
                              <button type="submit" class="btn w-100 add">
                                أضافة
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Add Modal End -->
            </div>
          </div>
          <div class="data">
            <div class="table-responsive">
              <table
                v-show="this.studentContent.length > 0"
                class="table table-striped"
              >
                <thead>
                  <tr>
                    <th class="fit" scope="col">الرقم</th>
                    <th>اسم الدرس</th>
                    <th>عدد المشاهدات</th>
                    <th>تاريخ الانتهاء</th>
                    <th>التحكم</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(content, index) in this.studentContent"
                    :key="index"
                  >
                    <th>{{ index + 1 }}</th>
                    <td>{{ content.fullInfo.title }}</td>
                    <td>{{ content.number_of_views }}</td>
                    <td>{{ content.expired_date }}</td>
                    <td>
                      <button
                        class="btn edit"
                        @click="updateSelectContent(content.content_id)"
                      >
                        <i class="fas fa-check ms-1"></i>
                        تجديد
                      </button>
                      <button
                        @click="deleteSelectContent(content.content_id)"
                        class="btn me-2 delete"
                      >
                        <i class="fas fa-trash-alt ms-1"></i>
                        حذف
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                v-show="
                  (!this.isloading && !this.studentContent) ||
                  this.studentContent.length == 0
                "
                class="empty-state"
              >
                <div class="empty-state__icon">
                  <i class="fas fa-folder"></i>
                </div>
                <h3 class="empty-state__text">
                  لا يوجد محتوى لهذا الطالب حتى الآن
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";
export default {
  data() {
    return {
      isloading: true,
      index: this.$route.params.index,
      studentContent: [],
      student: {},
      lessonSelect: {
        contents: [],
      },
      lessonsList: [],
      lessons: [],
      contentType: 1,
      videosList: [],
      code: {
        content_id: "",
        number_of_views: 3,
        expired_date: "",
        date_of_usage: null,
        fullInfo: {},
      },
      categories: [],
      selectedCategoryIDs: [],
      Maincategories: [],

      selectedCategory: null,
      selectedSubCategory: null,
      selectedSubSubCategory: null,

      subSelect: [],
      subSubSelect: [],
      subSubSubSelect: [],
    };
  },
  methods: {
    ...mapActions("studentsModule", [
      "fetchStudents",
      "getSubCollection",
      "getStudentById",
      "addContentToSudent",
      "renewContentViews",
      "deleteContentFromStudent",
    ]),
    ...mapActions("lessonsModule", ["fetchLessons"]),
    // Get all Lessons
    async getAllLessons() {
      this.lessons = this.lessonsList.filter((lesson) => {
        lesson.categories.includes(this.student.grade.id);
      });
      console.log("lessons", this.lessons);
    },

    // add Content
    addContent(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      let payload = {
        id: this.student.student_id,
        code: this.code,
      };
      if (Object.keys(payload.code.fullInfo).length > 0) {
        this.addContentToSudent(payload);
        this.clearAndShowSuccess("تم اضافة المحتوى للطالب");
        closeButton.click();
      }
    },
    // Update Content
    updateSelectContent(id) {
      let payload = {
        content_id: id,
        student_id: this.student.student_id,
      };
      this.renewContentViews(payload);
      this.clearAndShowSuccess("تم تجديد عدد المشاهدات للطالب");
    },
    // Delete Content
    deleteSelectContent(id) {
      let payload = {
        content_id: id,
        student_id: this.student.student_id,
      };
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا المحتوى؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم الحذف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteContentFromStudent(payload);
        }
      });
    },
    // -------------------
    setExpiredDate() {
      let date = new Date();
      date.setDate(date.getDate() + 7);
      this.code.expired_date = date.toISOString().substring(0, 10);
    },
    onSelectLesson(e) {
      this.lessonSelect = this.lessonsList[e];

      let videos = this.lessonSelect.contents.filter(
        (content) => content.type == 2
      );
      this.videosList = [...videos];

      // if Not Select Video
      this.code.content_id = this.lessonsList[e].lesson_id;
      this.code.fullInfo = this.lessonsList[e];
    },
    onSelectContent(e) {
      this.code.content_id = this.videosList[e].id;
      this.code.fullInfo = this.videosList[e];
    },
    //
    //
    onSelectMainCategory(e) {
      let title = e;
      let selectedCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      this.selectedCategoryIDs = [];
      this.subSelect = [];
      this.subSubSelect = [];
      this.subSubSubSelect = [];

      this.selectedCategoryIDs.push(selectedCategory.category_id);

      this.lessonsList = this.getLessons.filter(
        (lesson) => lesson.categories[0] == this.selectedCategoryIDs[0]
      );
      if (selectedCategory.sub_categories.length > 0) {
        this.subSelect.push(...selectedCategory.sub_categories);
      }
      document.getElementById("subCategory").value = 0;
    },
    // Sub Cateory
    onSelectSubCategory(e) {
      let title = e;
      let selectedSubCategory = this.subSelect.filter(
        (item) => item.title === title
      )[0];
      this.selectedCategoryIDs.splice(2, 1);
      this.lessonsList = [];
      this.selectedCategoryIDs[1] = selectedSubCategory.category_id;
      this.getLessons.forEach((lesson) => {
        if (
          lesson.categories[0] == this.selectedCategoryIDs[0] &&
          lesson.categories[1] == this.selectedCategoryIDs[1]
        )
          this.lessonsList.push(lesson);
      });

      this.subSubSelect = [];
      this.subSubSubSelect = [];
      if (selectedSubCategory.sub_categories.length > 0) {
        this.subSubSelect.push(...selectedSubCategory.sub_categories);
      }
    },
    // Sub Sub Cateory
    onSelectSubSubCategory(e) {
      let title = e;
      let selectedSubSubCategory = this.subSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.selectedCategoryIDs[2] = selectedSubSubCategory.category_id;
      this.lessonsList = [];
      this.getLessons.forEach((lesson) => {
        if (
          lesson.categories[0] == this.selectedCategoryIDs[0] &&
          lesson.categories[1] == this.selectedCategoryIDs[1] &&
          lesson.categories[2] == this.selectedCategoryIDs[2]
        )
          this.lessonsList.push(lesson);
      });
      this.subSubSubSelect = [];
      if (selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubSelect.push(...selectedSubSubCategory.sub_categories);
      }
    },

    onSelectSubSubSubCategory(e) {
      let title = e;
      let selectedSubSubSubCategory = this.subSubSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.selectedCategoryIDs[3] = selectedSubSubSubCategory.category_id;
      this.lessonsList = [];
      this.getLessons.forEach((lesson) => {
        if (
          lesson.categories[0] == this.selectedCategoryIDs[0] &&
          lesson.categories[1] == this.selectedCategoryIDs[1] &&
          lesson.categories[2] == this.selectedCategoryIDs[2] &&
          lesson.categories[3] == this.selectedCategoryIDs[3]
        )
          this.lessonsList.push(lesson);
      });
    },
    // Default Functions
    // Clear Input and Messages me Success
    clearAndShowSuccess(message) {
      this.successAdd(message);
      this.clearData();
    },
    // Toast Seccuss Message
    successAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // Clear Data
    clearData() {
      this.code = {
        content_id: "",
        number_of_views: 3,
        expired_date: "",
        fullInfo: {},
      };
      this.setExpiredDate();
    },
  },
  async created() {
    if (this.getStudents.length > 0) {
      this.getStudents.filter((student) => {
        if (student.student_id == this.index) {
          this.student = student;
          console.log(student);
        }
        console.log("state");
      });
    } else {
      this.student = await this.getStudentById(this.index);
      console.log("firebase");
    }

    this.fetchLessons();

    // this.getSubCollection(this.student.student_id);
    this.getSubCollection(this.$route.params.index);

    if (this.studentContent.length > 0) await this.getAllLessons();

    this.setExpiredDate();

    this.Maincategories = this.getCategories.filter(
      (item) => item.main_category === true
    );
  },
  computed: {
    ...mapGetters("studentsModule", [
      "getStudents",
      "getStudentContent",
      "getUpdateStudent",
      "isLoading",
      "isFirstLoad",
    ]),
    ...mapGetters("lessonsModule", ["getLessons"]),
    ...mapGetters("categoriesModule", ["getCategories"]),
  },
  mounted() {
    this.firstLoad = this.isFirstLoad;
    // this.student = this.getUpdateStudent;
    this.studentContent = this.getStudentContent;
    this.lessonsList = this.getLessons;
    this.categories = this.getCategories;
    // document.getElementById("mainCategory").value = 0;
  },
  watch: {
    // getUpdateStudent() {
    //   this.student = this.getUpdateStudent;
    // },
    getStudentContent() {
      this.studentContent = this.getStudentContent;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    getLessons() {
      this.lessonsList = this.getLessons;
    },
    getCategories() {
      this.categories = this.getCategories;
    },
  },
};
</script>
